import React, { Component } from 'react'

import Select, { components } from 'react-select'

class FilterSelect extends Component {
  constructor (props) {
    super(props)

    this.state = {
      value: { value: this.props.selectState, label: (this.props.selectState === 'all') ? this.props.selectText : this.props.selectLabels[this.props.selectState] }
    }
  }

  /**
   * Set the currently set value for the select field.
   */
  componentWillReceiveProps (nextProps) {
    this.setState({ value: { value: nextProps.selectState, label: (nextProps.selectState === 'all') ? nextProps.selectText : nextProps.selectLabels[nextProps.selectState] } })
  }

  render () {
    const { Option } = components

    const IconOption = (props) => (
      <Option {...props}>
        {props.data.link ? (
          <span><a href={props.data.link} target='_blank'>{props.data.label}</a><i className='fas fa-external-link-alt filter-link' /></span>
        ) : (
          <span>{props.data.label}</span>
        )}
      </Option>
    )

    const options = [
      { value: 'all', label: this.props.selectText }
    ]

    this.props.selectFilter.map((option) =>
      options.push({ value: option, label: this.props.selectLabels[option], link: this.props.selectLinks ? this.props.selectLinks[option] : '', isDisabled: this.props.selectLinks ? (this.props.selectLinks[option] ? true : (this.props.dynamicFilters ? !this.props.dynamicFilters.includes(option) : false)) : (this.props.dynamicFilters ? !this.props.dynamicFilters.includes(option) : false) })
    )
    if (this.props.sortByLabel) {
      options.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))
    }

    let isDisabledArray = options.map(option => option.isDisabled)
    let isNotEnabled = !isDisabledArray.includes(false)

    return (
      <Select isDisabled={isNotEnabled} className='select-dropdown-container' classNamePrefix='select-dropdown' options={options} components={{ Option: IconOption }} onMenuOpen={this.props.selectOpen} onChange={this.props.selectChange} value={this.state.value} />
    )
  }
}

export default FilterSelect
